export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?q=80&w=2000&auto=format&fit=crop",
  houses: "https://images.unsplash.com/photo-1722421492323-eaf9c401befe?q=80&w=1600&auto=format&fit=crop",
  pools: "https://images.unsplash.com/photo-1774519677410-9073d1f2d9f5?q=80&w=1600&auto=format&fit=crop",
  roofs: "https://images.unsplash.com/photo-1681049400158-0ff6249ac315?q=80&w=1600&auto=format&fit=crop",
  facades: "https://images.unsplash.com/photo-1761986757577-140af8859587?q=80&w=1600&auto=format&fit=crop",
  masonry: "https://images.unsplash.com/photo-1531834685032-c34bf0d84c77?q=80&w=1600&auto=format&fit=crop",
  tiling: "https://images.unsplash.com/photo-1723124280643-f883fd318ce5?q=80&w=1600&auto=format&fit=crop",
  concrete: "https://images.unsplash.com/photo-1669170930713-f7c778496177?q=80&w=1600&auto=format&fit=crop",
  rebar: "https://images.unsplash.com/photo-1530863506128-dc9eb5c3e0fc?q=80&w=1600&auto=format&fit=crop",
  aboutMain: "https://images.unsplash.com/photo-1582540730843-f4418d96ccbe?q=80&w=1400&auto=format&fit=crop",
  aboutSecond: "https://images.unsplash.com/photo-1574757987642-5755f0839101?q=80&w=1200&auto=format&fit=crop",
};

export const PHONE_DISPLAY = "+387 62 357 338";
export const PHONE_TEL = "tel:+38762357338";
export const WHATSAPP_DISPLAY = "+33 6 50 26 71 60";
export const WHATSAPP_NUMBER = "33650267160";
export const waLink = (msg) => `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
